// src/App.js
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar.js';
import Home from './pages/Home/Home.js';
import Products from './pages/Product/Products.js';
import ProductDetail from './pages/ProductDetails/ProductDetails.js';
import Testimonials from './pages/Testimonials/Testimonials.js';
import About from './pages/About/About.js';
import Contact from './pages/Contact/Contact.js';
import Footer from './components/Footer/Footer.js';
import ScrollToTop from './components/ScrollToTop/ScrollToTop.js';
import CancellationPolicy from './pages/CancellationPolicy/CancellationPolicy.js';
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions.js';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy.js';

function App() {
  return (
    <Router>
      <Navbar />
      <ScrollToTop /> 
      <div className="page-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
}

export default App;
